import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './QuickAnswers.css';

export default function QuickAnswers() {
  const cardRefs = useScrollReveal(4);

  return (
    <section className="quick-answers" id="quick-answers">
      <div className="quick-answers-container">
        
        <header className="quick-answers-header">
          <h2>Quick Answers</h2>
          <p>Everything you need to know about Playermaker 2.0 in Canada.</p>
        </header>

        <dl className="qa-list">
          <div className="qa-item" ref={(el) => (cardRefs.current[0] = el)}>
            <dt>What is Playermaker 2.0?</dt>
            <dd>
              Playermaker 2.0 is a FIFA-approved wearable smart soccer tracker that mounts directly to your cleats. 
              It tracks 15+ technical and physical metrics, including kick velocity, touches, release time, sprint count, 
              and left/right foot balance, providing professional-grade insights directly to your smartphone.
            </dd>
          </div>

          <div className="qa-item" ref={(el) => (cardRefs.current[1] = el)}>
            <dt>Where can I buy Playermaker in Canada?</dt>
            <dd>
              You can buy Playermaker 2.0 in Canada directly from iLoveThisGame.ca. We are the official authorized 
              retail partner for Canada, which means you receive free expedited shipping, pay no international duties 
              or border fees, and are fully covered by a Lifetime Warranty with an active subscription.
            </dd>
          </div>

          <div className="qa-item" ref={(el) => (cardRefs.current[2] = el)}>
            <dt>Is a subscription required to use Playermaker 2.0?</dt>
            <dd>
              No, a subscription is not required to use the core features of Playermaker 2.0. The device comes with 
              free access to the Playermaker app to view your essential match and training metrics. Optional premium 
              subscription plans are available in the app for advanced video tracking and pro-level analytics.
            </dd>
          </div>
          
          <div className="qa-item" ref={(el) => (cardRefs.current[3] = el)}>
            <dt>How does Playermaker attach to the boot?</dt>
            <dd>
              Playermaker uses durable, medical-grade silicone straps that slide over your cleats. The IMU sensors 
              snap securely into the straps. They are lightweight (6 grams each), waterproof, and designed to not 
              interfere with ball control or feel.
            </dd>
          </div>
        </dl>

      </div>
    </section>
  );
}
